import { create } from 'zustand'
import type { StoryWriterStatus } from '../types'

interface StoryWriterState {
  // Input
  inputText: string

  // Output
  outputText: string
  status: StoryWriterStatus
  errorMessage: string | null
  inputTokens: number | null
  outputTokens: number | null

  // Actions
  setInputText: (text: string) => void
  setOutputText: (text: string) => void
  appendOutputText: (chunk: string) => void
  setStatus: (status: StoryWriterStatus) => void
  setError: (message: string) => void
  setTokenUsage: (input: number, output: number) => void
  reset: () => void
}

const DEFAULT_STATE = {
  inputText: '',
  outputText: '',
  status: 'idle' as StoryWriterStatus,
  errorMessage: null,
  inputTokens: null,
  outputTokens: null,
}

export const useStoryWriterStore = create<StoryWriterState>((set) => ({
  ...DEFAULT_STATE,

  setInputText: (text) => set({ inputText: text }),
  setOutputText: (text) => set({ outputText: text }),
  appendOutputText: (chunk) =>
    set((state) => ({ outputText: state.outputText + chunk })),
  setStatus: (status) => set({ status }),
  setError: (message) => set({ status: 'error', errorMessage: message }),
  setTokenUsage: (input, output) =>
    set({ inputTokens: input, outputTokens: output }),
  reset: () => set(DEFAULT_STATE),
}))
